import React from 'react';
import { format } from 'date-fns';
import { SmartPayIntegrationModel } from '../types';

export const generateContent = (integrationData: SmartPayIntegrationModel) => {
    const formatObjectArrayValue = value => {
        // if not array return value as strings
        if (!Array.isArray(value)) return value.toString();

        if (value.length === 0) return 'N/A';

        // generate content out of the arrays that might come in
        return value.map(item => (
            <div className="border-b-2 border-grey-300 last-of-type:border-0 ">
                {typeof item === 'object' && !Array.isArray(item)
                    ? Object.keys(item).map(key => {
                          const separatedWordsName = key.split(/(?=[A-Z])/).join(' ');
                          const formattedName = separatedWordsName.charAt(0).toUpperCase() + separatedWordsName.slice(1);
                          return (
                              <div>
                                  {`${formattedName}: ${
                                      formattedName.indexOf('Date') > 0 ? format(item[key], 'DD.MM.YYYY HH:mm:ss') : item[key]
                                  }`}
                              </div>
                          );
                      })
                    : item}
            </div>
        ));
    };

    return (
        <div className="grid grid-cols-2 gap-4">
            {TABLES_FIELDS_LIST.map(table => {
                return (
                    <div className="border-2 border-grey-300 p-4">
                        <h3>{table.title}</h3>
                        {table.rows.map(row => {
                            return (
                                <div
                                    key={row.responseKey}
                                    className="flex py-2 border-t-2 border-grey-300 first-of-type:border-0">
                                    <div className="flex-1 font-semibold flex items-center">{row.title}</div>
                                    <div className="flex-1 ">
                                        {integrationData[row.responseKey] !== undefined
                                            ? row.title.indexOf('Date') > 0
                                                ? format(integrationData[row.responseKey], 'DD.MM.YYYY HH:mm:ss')
                                                : formatObjectArrayValue(integrationData[row.responseKey])
                                            : 'N/A'}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
};

const TABLES_FIELDS_LIST = [
    {
        title: 'Integration Details',
        rows: [
            {
                responseKey: 'agreementNumber',
                title: 'Agreement Number',
            },
            {
                responseKey: 'cvr',
                title: 'CVR',
            },
            {
                responseKey: 'novemberFirstCustomerNumber',
                title: 'November First Customer Number',
            },
            {
                responseKey: 'status',
                title: 'Onboarding Status',
            },
            {
                responseKey: 'signupDate',
                title: 'Smart Pay Signup Date',
            },
            {
                responseKey: 'customerType',
                title: 'Customer Type',
            },
            {
                responseKey: 'validationReadyDate',
                title: 'Validation Ready Date',
            },
            {
                responseKey: 'approvalDate',
                title: 'N1 Approval Date',
            },
            {
                responseKey: 'autoWithdrawActiveDate',
                title: 'OS Active Date',
            },
            {
                responseKey: 'autoWithdrawAppliedDate',
                title: 'OS Applied Date',
            },
            {
                responseKey: 'subscriptionType',
                title: 'Subscription Type',
            },
            {
                responseKey: 'subscriptionModuleSubscriptionDate',
                title: 'Subscription Module Subscription Date',
            },
            {
                responseKey: 'novemberFirstAppPublicKeyHasValue',
                title: 'Is Integration Active',
            },
            {
                responseKey: 'disabled',
                title: 'Integration Disabled',
            },
        ],
    },

    {
        title: 'Other',
        rows: [
            {
                responseKey: 'creationDate',
                title: 'N1 Onboarding Date',
            },

            {
                responseKey: 'daybook',
                title: 'Daybook',
            },
            {
                responseKey: 'feeAccount',
                title: 'Fee Account',
            },
            {
                responseKey: 'useNovemberFirstDemoEnvironment',
                title: 'Is Demo',
            },
            {
                responseKey: 'discount',
                title: 'Discount',
            },
            {
                responseKey: 'discountValidFrom',
                title: 'Discount From Date',
            },
            {
                responseKey: 'discountValidTo',
                title: 'Discount To Date',
            },
        ],
    },

    {
        title: 'Onboarder Information',
        rows: [
            {
                responseKey: 'contact',
                title: 'Onboarder Name',
            },
            {
                responseKey: 'email',
                title: 'Onboarder Email',
            },
            {
                responseKey: 'telephone',
                title: 'Onboarder Telephone',
            },
        ],
    },

    {
        title: 'Missing Information',
        rows: [
            {
                responseKey: 'missingInformation',
                title: 'Missing Information',
            },
        ],
    },
];
